import { css } from 'linaria';

export const nyTreeFirstStyle = css`
  && {
    margin-top: 80px;

    @media (--only-tablet) {
      margin-top: 64px;
    }

    @media (--only-mobile) {
      margin-top: 40px;
    }
  }
`;

export const nyTreeRetroStyle = css`
  && {
    margin-top: 48px;

    @media (--only-tablet) {
      margin-top: 44px;
    }

    @media (--only-mobile) {
      margin-top: 28px;
    }
  }
`;
